<template>
    <app-data-table
        :fields="fields"
        :items="data.data"
        @sort="onSort"
        :current-page="data.current_page"
        :last-page="data.last_page"
        :from="data.from"
        :to="data.to"
        :total="data.total"
        :per-page="data.per_page"
        :on-change-page="onChangePage"
    >
        <template slot="main" slot-scope="{ item }">
            {{ item.main | yesno }}
        </template>
        <template slot="actions" slot-scope="{ item }">
            <b-button size="sm" variant="primary" title="Ingresar al comercio" @click="loginStore(item)"><i class="fa fa-sign-in" aria-hidden="true"></i></b-button>
            <b-button size="sm" variant="primary" title="modificar al comercio" @click="updateStore(item)"><i class="fa fa-pencil"></i></b-button>
            <b-button size="sm" variant="danger" title="Eliminar el comercio" @click="removeStore(item)"><i class="fa fa-trash"></i></b-button>
        </template>
    </app-data-table>
</template>
<script>
import fields from './fields';
export default {
    props: {
        data: {
            type: Object
        }
    },
    data(){
        return {
            fields
        }
    },
    methods: {
        onChangePage(page){
            this.$emit('change-page', page);
        },
        updateStore(data){
            this.$emit('update-store', data);
        },
        removeStore(data){
            this.$emit('remove-store', data);
        },
        loginStore(data){
            this.$emit('login-store', data);
        },
        onSort(ctx) {
            this.$emit('sort', ctx);
        },
    }
}
</script>